import React from 'react';
import { Card, Title } from '@mantine/core';
import {
  BarChart, Bar, PieChart, Pie, XAxis, YAxis, 
  CartesianGrid, Tooltip, Legend, ResponsiveContainer, Cell
} from 'recharts';
import { useMediaQuery } from "@mantine/hooks";

export interface SymptomData {
  name: string;
  value: number;
}

interface ChartComponentProps {
  type: 'bar' | 'pie';
  data: SymptomData[];
  title: string;
}

const colors: string[] = ['#5E72E4', '#F5365C', '#FFD600', '#2DCE89', '#11CDEF', '#FB6340'];

const ChartComponent: React.FC<ChartComponentProps> = ({ type, data, title }) => {
  const isMobile = useMediaQuery("(max-width: 768px)");

  return (
    <Card shadow="sm" p="lg" radius="md" withBorder className="chart-card">
      <Title order={3} mb="md">{title}</Title>
      <ResponsiveContainer width="100%" height={300}>
        {type === "bar" ? (
          <BarChart data={data}>
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Bar dataKey="value">
              {data.map((entry: SymptomData, index: number) => (
                <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
              ))}
            </Bar>
          </BarChart>
        ) : (
          <PieChart>
            <Pie
              data={data}
              cx="50%"
              cy="50%"
              labelLine={false}
              outerRadius={isMobile ? 80 : 100}   // shrink a bit on mobile
              fill="#8884d8"
              dataKey="value"
              nameKey="name"
              label={
                isMobile
                  ? ({ percent }) => `${(percent * 100).toFixed(0)}%`
                  : ({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`
              }
            >
              {data.map((entry: SymptomData, index: number) => (
                <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
              ))}
            </Pie>
            <Tooltip />
            <Legend />
          </PieChart>
        )}
      </ResponsiveContainer>
    </Card>
  );
};


export default ChartComponent;